import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import TeamDetailPage from './pages/TeamDetailPage';

function App() {
  return (
    <Router basename="/vrproject">
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/team/:teamId" element={<TeamDetailPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
